/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown>, workflow: NonNullable<unknown> }} Pwf_DoneInputs */

const en_pwf_done = /** @type {(inputs: Pwf_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.product} now uses ${i?.workflow}`)
};

const de_pwf_done = /** @type {(inputs: Pwf_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.product} nutzt jetzt ${i?.workflow}`)
};

/**
* | output |
* | --- |
* | "{product} now uses {workflow}" |
*
* @param {Pwf_DoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_done = /** @type {((inputs: Pwf_DoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_DoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_done(inputs)
	return en_pwf_done(inputs)
});